module.exports = {
        srcSet: "/_next/static/images/bloomberg@3x-161-6db4a03c53d8591e.png"+" 161w"+","+"/_next/static/images/bloomberg@3x-322-a40b2c4270a25e88.png"+" 322w"+","+"/_next/static/images/bloomberg@3x-468-d5a6f83eb938864a.png"+" 468w",
        images: [{path: "/_next/static/images/bloomberg@3x-161-6db4a03c53d8591e.png",width: 161,height: 30},{path: "/_next/static/images/bloomberg@3x-322-a40b2c4270a25e88.png",width: 322,height: 60},{path: "/_next/static/images/bloomberg@3x-468-d5a6f83eb938864a.png",width: 468,height: 87}],
        src: "/_next/static/images/bloomberg@3x-468-d5a6f83eb938864a.png",
        toString: function(){return "/_next/static/images/bloomberg@3x-468-d5a6f83eb938864a.png"},
        
        width: 468,
        height: 87
      }